/**
 * Home.js
 * Author: Markus.van.Kempen@gmail.com
 * Date: 2nd Nov 2025
 * Updated: Jul 2026 — stronger SEO title/description + Organization/WebSite JSON-LD
 */

import React from 'react';
import EditablePage from './EditablePage';
import HomeAnnouncement from './HomeAnnouncement';
import SEO from './SEO';

const HOME_TITLE =
  'Cranford Publications - Celtic Fiddle Music Shop | Cape Breton, Scottish & Irish Traditional Music';
const HOME_DESCRIPTION =
  'Celtic fiddle music from Cape Breton, Ireland and Scotland since 1979. Founded by Paul Stewart Cranford, lighthouse keeper and fiddler. 2,500+ tunes, books, CDs, and educational materials. Worldwide shipping.';
const BASE_URL = 'https://www.cranfordpub.ca';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${BASE_URL}/#organization`,
      name: 'Cranford Publications',
      url: BASE_URL,
      logo: `${BASE_URL}/images/android-chrome-512x512.png`,
      image: `${BASE_URL}/images/collage9.jpg`,
      description: HOME_DESCRIPTION,
      foundingDate: '1979',
      email: 'cranfordpub@gmail.com',
      telephone: '+1-902-929-2391',
      address: {
        '@type': 'PostalAddress',
        addressRegion: 'Nova Scotia',
        addressCountry: 'CA',
      },
      founder: {
        '@type': 'Person',
        name: 'Paul Stewart Cranford',
        jobTitle: 'Fiddler, composer, and music publisher',
      },
      sameAs: [],
    },
    {
      '@type': 'WebSite',
      '@id': `${BASE_URL}/#website`,
      url: BASE_URL,
      name: 'Cranford Publications',
      description: HOME_DESCRIPTION,
      publisher: { '@id': `${BASE_URL}/#organization` },
      inLanguage: 'en-CA',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${BASE_URL}/shop?search={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      '@id': `${BASE_URL}/#webpage`,
      url: BASE_URL,
      name: HOME_TITLE,
      description: HOME_DESCRIPTION,
      isPartOf: { '@id': `${BASE_URL}/#website` },
      about: { '@id': `${BASE_URL}/#organization` },
      primaryImageOfPage: `${BASE_URL}/images/collage9.jpg`,
    },
  ],
};

const Home = () => {
  return (
    <>
      <SEO
        title={HOME_TITLE}
        description={HOME_DESCRIPTION}
        canonical="/"
        keywords="Cranford Publications, celtic music, fiddle music, Cape Breton music, Irish music, Scottish music, traditional music, music books, fiddle books, Paul Cranford, Cape Breton Musical Heritage"
        jsonLd={homeJsonLd}
      />
      <HomeAnnouncement />
      <EditablePage pageId="home" pageTitle="Home" floatingSharePath="/" />
    </>
  );
};

export default Home; 